import Column from '@components/Column';
import CtaLayout from '@components/CtaLayout';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import Fab from './components/Fab';
import ShopSelector from './components/ShopSelector';
import StampCards from './components/StampCards';
import StampHeader from './components/StampHeader';
import StampHistories from './components/StampHistories';
import StampNote from './components/StampNote';

declare module '@stackflow/config' {
    interface Register {
        StampsActivity: {};
    }
}

const StampsActivity: ActivityComponentType<'StampsActivity'> = () => (
    <AppScreen backgroundColor={colors.gray1}>
        <CtaLayout header={<StampHeader/>}>
            <Container spacing={24} fullWidth>
                <ShopSelector/>
                <StampCards/>
                <StampHistories/>
            </Container>
            <StampNote/>
            <Spacer/>
            <Fab/>
        </CtaLayout>
    </AppScreen>
);

const Container = styled(Column)`
    padding: 16px 0 ;
`;

const Spacer = styled.div`
    width: 100%;
    height: var(--safe-area-bottom);
    min-height: var(--safe-area-bottom);
`;

export default StampsActivity;
